// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"29760aff","287":"02d14db1","290":"d00008d1","344":"300232e6","453":"3f1fb51b","550":"0868a26a","608":"48ff346d","841":"d5b31acb"}[chunkId] + ".chunk.js";
};